import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-plans-card',
  templateUrl: './plans-card.component.html',
  styleUrls: ['./plans-card.component.css']
})
export class PlansCardComponent implements OnInit {
 
  isDashboard: boolean = true;
  isFoodPlan: boolean = false;
  isActivityPlan: boolean = false;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );

  constructor(
    private breakpointObserver: BreakpointObserver
  ) {
    console.log("here in log card constructor");
  }

  ngOnInit() {
    console.log("here in log card init");
  }

  toggleDashboard() {
    console.log("toggling dashboard");
    this.isDashboard = !this.isDashboard;
    console.log(this.isDashboard);
  }

  toggleFoodPlan() {
    console.log("toggling food log");
    this.isFoodPlan = !this.isFoodPlan;
    console.log(this.isFoodPlan);
  }

  toggleActivityPlan() {
    console.log("toggling food log");
    this.isActivityPlan = !this.isActivityPlan;
    console.log(this.isActivityPlan);
  }
}
